/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_ALL_INELIGIBLE_CPT_DATA = 'GET_ALL_INELIGIBLE_CPT_DATA';
export const HANDLE_ERROR_MESSAGE_MICPT = 'HANDLE_ERROR_MESSAGE_MICPT';
export const SET_GRID_DATA_INELIGIBLE_CPT = 'SET_GRID_DATA_INELIGIBLE_CPT';
export const INELIGIBLE_CPT_ADD_EDIT_RES = 'INELIGIBLE_CPT_ADD_EDIT_RES';
export const RESET_INELIGIBLE_CPT_REDUX_STORE =
  'RESET_INELIGIBLE_CPT_REDUX_STORE';
export const SET_DELETED_DATA_INELIGIBLE_CPT =
  'SET_DELETED_DATA_INELIGIBLE_CPT';
